import React, { useState, useEffect } from "react";
import { useHistory } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { Breadcrumb, Divider, Steps } from "antd";
import { resetStatement, uploadBatch } from "../../../store/slices/statements";
import StatementUploadForm from "../StatementUploadForm/StatementUploadForm";
import rtkRequestStatusCodes from "../../../lib/const/rtkRequestStatusCodes";
import "./StatementUpload.less";

const { Step } = Steps;

const renderSteps = () => (
  <Steps size="small" current={1} className="upload-statement__steps">
    <Step title="Выписки" />
    <Step title="Разбиение платежей" />
  </Steps>
);

const StatementUpload = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [formState, setFormState] = useState("initial");
  const { statementLoading } = useSelector((state) => state.statements);
  const isUploading = formState === "requested";

  useEffect(() => {
    if (formState === "requested" && statementLoading === rtkRequestStatusCodes.fulfilled) {
      setFormState("uploaded");
    }

    if (statementLoading === rtkRequestStatusCodes.pending) {
      setFormState("requested");
    }

    if (formState === "requested" && statementLoading === rtkRequestStatusCodes.rejected) {
      setFormState("failure");
    }
  }, [statementLoading, formState]);

  const sendFile = ({ fromDate, currencyId, file }) => {
    const fd = new FormData();
    fd.append("file", file.originFileObj);

    const uploadParams = {
      file: fd,
      currencyId,
      batchDate: moment(fromDate).format("YYYY-MM-DD"),
    };

    dispatch(uploadBatch(uploadParams)).then((data) => {
      const path = data.payload?.content?.[0]?.batch?.id;
      if (path) history.push(`/statements/${path}`);
    });
  };

  const handleCancel = () => {
    history.goBack();
    dispatch(resetStatement());
  };

  return (
    <>
      <>
        <Breadcrumb className="statements__breadcrumb">
          <Breadcrumb.Item href="/statements">Банковские выписки</Breadcrumb.Item>
          <Breadcrumb.Item>Загрузка файла</Breadcrumb.Item>
        </Breadcrumb>
        <h1>Загрузка файла</h1>
        {renderSteps()}
      </>
      <Divider className="divider_thin" />
      <StatementUploadForm cancel={handleCancel} sendFile={sendFile} isUploading={isUploading} />
    </>
  );
};

export default StatementUpload;
